<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-md-4 col-sm-12">Menu navigation</h4>
                    <div class="col-md-8 col-sm-12 d-flex justify-content-end">
                        <div *ngIf="!isSearch">
                            <a class="btn btn-primary" [class.disabled]="loading.status" routerLink="add">
                                Add New
                            </a>
                            <button title="Refresh" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="getData()">
                                <i class="material-icons">refresh</i>
                            </button>
                            <button title="Search" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="isSearch=true">
                                <i class="material-icons">search</i>
                            </button>
                        </div>
                        <div *ngIf="isSearch" class="w-100">
                            <div class="input-group has-search">
                                <span class="input-group-text pt-0 pb-0 bg-white border-secondary">
                                    <i class="material-icons">search</i>
                                </span>
                                <input type="search" [(ngModel)]="query.q" (keyup)="searchData($event)" class="form-control border-start-0 ps-1 shadow-none border-secondary" placeholder="Type and hit Enter...">
                                <button title="Search" class="btn btn-secondary" [attr.disabled]="loading.status ? 'disabled' : null" (click)="query.q=null;isSearch=false;getData()">
                                    <i class="material-icons">close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pt-2">
                    <div class="col-12">
                        <div class="text-center h4 p-3" *ngIf="!data?.data?.length">
                            <div *ngIf="loading.status">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div *ngIf="!loading.status">
                                No data found
                            </div>
                        </div>
                        <table class="table table-bordered table-striped" *ngIf="data?.data?.length">
                            <thead>
                                <tr>
                                    <th>
                                        #
                                    </th>
                                    <th>
                                        Parent
                                    </th>
                                    <th>
                                        Menu
                                    </th>
                                    <th>
                                        Link
                                    </th>
                                    <th>
                                        Position
                                    </th>
                                    <th>
                                        Status
                                    </th>
                                    <th>
                                        Created at
                                    </th>
                                    <th>
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of data?.data;let i=index;">
                                    <td>
                                        {{i+1}}
                                    </td>
                                    <td>
                                        {{item.parent?.name || '-'}}
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <i class="material-icons me-2">
                                                {{item.icon}}
                                            </i> {{item.name}}
                                        </div>
                                    </td>
                                    <td>
                                        {{item.link || '-'}}
                                    </td>
                                    <td>
                                        {{item.position}}
                                    </td>
                                    <td>
                                        {{item.status?'Aktif':'Inactive'}}
                                    </td>
                                    <td>
                                        {{util.formatDate(item.created_at, 'DD MMM YYYY, HH:mm')}}
                                    </td>
                                    <td class="text-center" nowrap>
                                        <a class="btn btn-primary btn-sm" [class.disabled]="loading.status" title="Edit" routerLink="edit/{{item.id}}">
                                            <i class="material-icons">edit</i>
                                        </a>
                                        &nbsp;
                                        <button [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-danger btn-sm" title="Delete" (click)="deleteDialog.show([item.id])">
                                            <i class="material-icons">delete</i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #deleteModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Delete</h5>
    </div>
    <div class="modal-body">
        Are you sure want to delete this data?
    </div>
    <div class="modal-footer d-flex justify-content-between">
        <div>
            <div class="spinner-border text-primary" role="status" *ngIf="deleteDialog.isDeleting && loading.status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="text-end">
            <button type="button" class="btn btn-primary" (click)="modal.close()" [attr.disabled]="loading.status ? 'disabled' : null">Cancel</button>
            &nbsp;
            <button type="button" class="btn btn-danger" (click)="deleteDialog.submit()" [attr.disabled]="loading.status ? 'disabled' : null">Delete</button>
        </div>
    </div>
</ng-template>
